export default __webpack_public_path__ + "static/media/Clan Bound Fauld of the Tribes.d380f244.jpg";